class DoorRequestConfiguration {
    setName;
    doorsSittingOn;
    doors = [];
    customWidth;
    customHeight;
    frameStyle; 
    frameColor;
    trackStyle;

    constructor() { }

    toString() {
        return JSON.stringify(this);
    }

}